<div class="scss-website-background-color">
    @switch (Scope.websiteMode) {
        @case (WebsiteMode.Live) {
            <div class="d-flex justify-content-center position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.ReadOnly) {
            <div class="d-flex justify-content-center position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.Preview) {
            <lib-design-blocks-action-menu>
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </lib-design-blocks-action-menu>
        }
    }
</div>

<ng-template #blockContent>
    @if (type !== WebsiteBlockTextAndMediaType.PhotoGalleryGrid && Scope.websiteMode != WebsiteMode.ReadOnly) {
    <div class="carousel-control-prev d-none d-md-flex align-items-center">
        <lib-button
            [kind]="ButtonKind.Neutral"
            [iconOnly]="true"
            [size]="ButtonSize.Large"
            [prefixIcon]="Icon.Common.ChevronLeft"
            (clicked)="Previous()">
        </lib-button>
    </div>
    }
    <div class="w-100" (touchstart)="Swipe($event, true)" (touchend)="Swipe($event, false)" [ngClass]="{
        'photo-gallery-grid-block': type === WebsiteBlockTextAndMediaType.PhotoGalleryGrid,
        'photo-gallery-caraousel-block': type !== WebsiteBlockTextAndMediaType.PhotoGalleryGrid}">

        <ng-content></ng-content>

        <!-- Indicator Dots -->
        @if (type !== WebsiteBlockTextAndMediaType.PhotoGalleryGrid) {
        <div class="d-flex justify-content-center gap-2 w-100 carousel-indicator-container">
            <div *ngFor="let _ of images, let index = index"
                class="rounded-circle carousel-indicator"
                [ngClass]="{'indicator-active': index === middleImageIndex, 'indicator-inactive': index !== middleImageIndex }"
                (click)="middleImageIndex = index">
            </div>
        </div>
        }

    </div>
    @if (type !== WebsiteBlockTextAndMediaType.PhotoGalleryGrid && Scope.websiteMode != WebsiteMode.ReadOnly) {
    <div class="carousel-control-next d-none d-md-flex align-items-center">
        <lib-button
            [kind]="ButtonKind.Neutral"
            [iconOnly]="true"
            [prefixIcon]="Icon.Common.ChevronRight"
            [size]="ButtonSize.Large"
            (clicked)="Next()">
        </lib-button>
    </div>
    }

</ng-template>